import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContentCardsContext, ContentCardsContextType } from './Context';
import { ContentCardProps } from './types';

export const useContentCards = (): ContentCardsContextType => {
  const context = useContext(ContentCardsContext);
  if (!context) {
    throw new Error(
      'useContentCards must be used within a ContentCardsProvider'
    );
  }

  return context;
};

export interface CardHandlers {
  handleCardClick: () => void;
  handleDismiss: (e: MouseEvent) => void;
}

export const useCardHandlers = ({
  card,
  onCardClick,
  onCardDismiss
}: ContentCardProps): CardHandlers => {
  const navigate = useNavigate();

  const handleCardClick = useCallback(() => {
    onCardClick(card);
    if (card.url) navigate(card.url);
  }, [onCardClick, card, navigate]);

  const handleDismiss = useCallback(() => {
    onCardDismiss(card);
  }, [onCardDismiss, card]);

  return { handleCardClick, handleDismiss };
};
